var exports = {
  "nM": "row__9haL2S",
  "hZ": "trigger__VUtRqD",
  "rf": "body__UOR3Rz",
  "R_": "heading__ZwD7f1",
  "UU": "name__cWWB6Z",
  "h_": "description__0U_K_c",
  "ZY": "trailing__OHjd25",
  "Ng": "connect__co_NC9",
};

module.exports = exports;
